import { AppCard } from "@/components/ui";
import { AlertTriangle } from "lucide-react";

type TGapsWeaknessesCardProps = {
  gapsOrWeaknesses?: string[] | null;
};

export function GapsWeaknessesCard({ gapsOrWeaknesses }: TGapsWeaknessesCardProps) {
  if (!gapsOrWeaknesses || gapsOrWeaknesses.length === 0) {
    return null;
  }

  return (
    <AppCard className="p-6">
      <div className="mb-4 flex items-center gap-4">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-orange-100">
          <AlertTriangle className="h-5 w-5 text-orange-600" />
        </div>
        <h3 className="text-lg font-semibold text-foreground">Gaps & Weaknesses</h3>
      </div>
      <ul className="space-y-4">
        {gapsOrWeaknesses.map((gap, index) => (
          <li
            key={index}
            className="flex items-start gap-4"
          >
            <div className="mt-0.5 flex-shrink-0">
              <AlertTriangle className="h-5 w-5 text-orange-600" />
            </div>
            <p className="text-sm leading-relaxed text-foreground">{gap}</p>
          </li>
        ))}
      </ul>
    </AppCard>
  );
}
